import {
    DatePipe,
    DecimalPipe,
    HashLocationStrategy,
    LocationStrategy,
    CurrencyPipe,
    LowerCasePipe
} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule, provideZonelessChangeDetection, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthConfig, OAuthModule } from '@nationwide/angular-oauth-module';
import { APICommonService, BrowserUtilsService } from '@nationwide/internet-servicing-angular-services';
import { BillingServicesModule, EnterpriseLegalAgreementsService } from '@nationwide/dgs-angular-billing-common';
import { AppRoutingModule } from './app-routing.module';
import { AppServiceConfigModule } from './app-service-config.module';
import { AppComponent } from './app.component';
import { LoggerService } from './shared/logger/logger.service';
import { SessionServicesModule } from './shared/session/session-services.module';
import { ISBSharedComponentsModule } from './shared/shared-components.module';
import { ISBSharedServicesModule } from './shared/shared-services.module';
import { BillingTileAdapterModule } from '@nationwide/angular-billing-tile';
import { AccountValidationAdapter } from './account-validation/account-validation-adapter.service';
import { ConsumerConfigurerService } from './billing-timeline-widget/service/consumer-configurer.service';

import { CookieModule, CookieService } from 'ngx-cookie';
import { IsbSharedCommonHelperService } from './shared/isb-shared-common-helper.service';
import { ManageAccountValidationService } from './account-validation/manage-account-validation.service';
import { ManagePaymentPreferencesModule } from './billing/payment-preferences/manage/manage-payment-preferences.module';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { DistributionPartnerRoleInfoService } from './billing/shared/distribution-partner-role-info/distribution-partner-role-info.service';
import { DistributionPartnerRoleInfoHelperService } from './billing/shared/distribution-partner-role-info/distribution-partner-role-info-helper.service';
import { DistributionPartnerRoleInfoAdapter } from './billing/shared/distribution-partner-role-info/distribution-partner-role-info.adapter';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FooterService } from './shared/footer/footer.service';
import { EasternTimeDatePipe, OrderByPipe, RemoveDuplicatesPipe, SafeDatePipe, SentenceCasePipe } from '@nationwide/internet-servicing-angular-pipes';
import { InternetServicingBillingErrorHandler } from './shared/internet-servicing-billing-error-handler';
import { BoltDirectivesModule } from '@nationwide-bolt/ng-directives';
import { FooterComponent, WaitMessageComponent } from '@nationwide/internet-servicing-angular-components';
import { OauthClientService } from './shared/oauth-client.service';
import { IframeComponent } from './shared/iframe/iframe.component';
import { IframeWrapperComponent } from './shared/iframe-wrapper/iframe-wrapper.component';
import { TimelineModule } from '@nationwide/angular-timeline';
import { TitleCasePipe } from '@angular/common';
import { provideInternetServicingPolicyRequests } from '@nationwide/dgs-internet-servicing-policy-requests';
import { provideDocumentsTile } from '@nationwide/personal-component-library-documents-tile';
import { PING_REDIRECT_INITIALIZER } from './shared/service/ping-redirect/ping-redirect.initializer';
@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        OAuthModule,
        BillingServicesModule,
        AppRoutingModule,
        AppServiceConfigModule,
        SessionServicesModule,
        ISBSharedServicesModule,
        CookieModule.withOptions(),
        ISBSharedComponentsModule,
        BillingTileAdapterModule,
        ManagePaymentPreferencesModule,
        BoltDirectivesModule,
        TimelineModule,
        IframeWrapperComponent,
        IframeComponent,
        FooterComponent,
        WaitMessageComponent
    ],
    declarations: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        IframeWrapperComponent,
        IframeComponent
    ],
    providers: [
        PING_REDIRECT_INITIALIZER,
        { provide: 'servicingCommonConfig', useValue: environment },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: 'logger', useClass: LoggerService },
        { provide: 'vinConfig', useValue: environment.GLOBAL_NAV },
        { provide: 'policyRequestsConfig', useValue: environment.POLICY_REQUESTS },
        { provide: 'contentfulConfig', useFactory: (): any => environment.contentful },
        { provide: 'globalNavConfig', useValue: environment },
        { provide: 'ctAuthConfig', useFactory: (): OAuthConfig => environment.OAUTH_CONFIG },
        { provide: 'contentfulTestConfig', useFactory: (): any => environment.contentful },
        { provide: ErrorHandler, useClass: InternetServicingBillingErrorHandler },
        provideZonelessChangeDetection(),
        provideInternetServicingPolicyRequests(),
        provideDocumentsTile(),
        // ToDo figure out what requires these
        APICommonService,
        BrowserUtilsService,
        DatePipe,
        DecimalPipe,
        CurrencyPipe,
        LowerCasePipe,
        RemoveDuplicatesPipe,
        EasternTimeDatePipe,
        SafeDatePipe,
        OrderByPipe,
        SentenceCasePipe,
        TitleCasePipe,
        AccountValidationAdapter,
        ConsumerConfigurerService,
        CookieService,
        IsbSharedCommonHelperService,
        ManageAccountValidationService,
        DistributionPartnerRoleInfoService,
        DistributionPartnerRoleInfoHelperService,
        DistributionPartnerRoleInfoAdapter,
        NgbActiveModal,
        FooterService,
        OauthClientService,
        EnterpriseLegalAgreementsService,
        OrderByPipe,
        SentenceCasePipe,
        provideDocumentsTile()
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
